<template>
  <div>
    <span style="visibility: hidden">
      -----------------------------------------------------------------------------------------------------------
    </span>
    <v-treeview
      :items="legenda"
      dense
      open-on-click
    >
      <template v-slot:label="{ item }">
        <span
          v-if="item.root"
          class="font-weight-bold caption"
          width="300"
        >{{
          item.nome
        }}</span>
        <span
          v-else
          class="caption"
        >
          <span
            class="font-weight-bold"
            :style="`color: ${item.color}`"
          >{{ item.descricao }}:</span>
          {{ item.descricaoAcao }}
        </span>
      </template>
    </v-treeview>
  </div>
</template>

<script>
export default {
  computed: {
    legenda() {
      return [
        {
          root: true,
          nome: 'Legenda CDS:',
          children: [
            {
              id: 'NAO_ATENDE',
              nome: 'Não Atende',
              descricao: 'Não Atende',
              descricaoAcao: 'CDS menor que 4.',
              color: '#348ECA',
            },
            {
              id: 'EM_DESENVOLVIMENTO',
              nome: 'Em Desenvolvimento',
              descricao: 'Em Desenvolvimento',
              descricaoAcao: 'CDS entre 4 e 8.',
              color: '#2D5269',
            },
            {
              id: 'ATENDE',
              nome: 'Atende',
              descricao: 'Atende',
              descricaoAcao: 'CDS maior que 8.',
              color: '#00ABA4',
            },
          ],
        },
      ];
    },
  },
};
</script>
